const STORAGE_KEY = 'grapple_referral_url';
const DEAL_ID_KEY = 'grapple_referral_deal_id';
const GRAPPLE_LAW_URL = /^https:\/\/(www|stage)\.grapple\.law\//;

export const GRAPPLE_THANK_YOU_PAGE = '/thank-you-grapple';

// Keeps the client's Grapple Law sign-up link for the thank-you page when rota marks the enquiry Tier 4.
// get-deal-details returns the deal id as `dealID`, create-deal as `id`.
export const saveGrappleReferral = (deal) => {
  try {
    if (deal?.is_tier_4 === 'yes' && GRAPPLE_LAW_URL.test(deal?.grapple_law_url ?? '')) {
      sessionStorage.setItem(STORAGE_KEY, deal.grapple_law_url);
      const dealId = Number(deal?.dealID ?? deal?.id);
      if (Number.isInteger(dealId) && dealId > 0) {
        sessionStorage.setItem(DEAL_ID_KEY, String(dealId));
      } else {
        sessionStorage.removeItem(DEAL_ID_KEY);
      }
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
      sessionStorage.removeItem(DEAL_ID_KEY);
    }
  } catch (e) {
    console.error(e);
  }
};

export const getGrappleReferral = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch (e) {
    return null;
  }
};

export const getGrappleReferralDealId = () => {
  try {
    return sessionStorage.getItem(DEAL_ID_KEY);
  } catch (e) {
    return null;
  }
};

// Every Tier 4 enquiry with a Grapple referral now sees the Grapple thank-you page.
export const thankYouPageFor = (standardPage) =>
  getGrappleReferral() ? GRAPPLE_THANK_YOU_PAGE : standardPage;

// Split test: the START MY CASE button sends even Pipedrive deal ids to Grapple's chat
// (same landing as the App3 email) and odd ones to the sign-up page they had before.
// Both keep the imported Monaco details. Without a deal id they keep the sign-up page.
export const grappleLandingFor = (referralUrl, dealId) => {
  const id = Number(dealId);
  if (!Number.isInteger(id) || id <= 0 || id % 2 === 1) return referralUrl;
  return referralUrl.replace(/\/sign-up(?=[?#]|$)/, '/chat');
};
